import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import './index.css';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

// Auth0が設定されているかチェック
const isAuth0Configured = domain && clientId;

const root = ReactDOM.createRoot(document.getElementById('root'));

if (isAuth0Configured) {
  root.render(
    <React.StrictMode>
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: audience,
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
      >
        <App />
      </Auth0Provider>
    </React.StrictMode>
  );
} else if (process.env.NODE_ENV === 'production') {
  // 本番ビルドでは Auth0 未設定のまま起動しない（認証なしで管理画面が開くのを防ぐ）
  console.error('Auth0が設定されていません。環境変数を確認してください。');
  root.render(
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>管理者画面を表示できません</h1>
      <p>認証の設定が完了していません。管理者にお問い合わせください。</p>
    </div>
  );
} else {
  // 開発環境のみ: Auth0が未設定の場合は認証なしで表示
  console.warn('Auth0が設定されていません。認証なしモードで起動します。');
  root.render(
    <React.StrictMode>
      <App skipAuth={true} />
    </React.StrictMode>
  );
}

